import pickBy from "lodash/pickBy";

import {
  PaymasterFilter,
  PaymasterStatusFilterOptions,
  StringFilterMode,
} from "../../graphql/generated.ts";
import { PaymasterFiltersValue } from "./types.ts";

export const getPaymasterApiFilter = (
  value: PaymasterFiltersValue
): PaymasterFilter => {
  return pickBy({
    status: { equals: PaymasterStatusFilterOptions.Active },
    customerPaymasters: value.customerId?.length && {
      some: { customerId: { in: value.customerId.map(Number) } },
    },
    name: value.name && {
      contains: value.name,
      mode: StringFilterMode.Insensitive,
    },
    score: value.score && { equals: value.score },
  });
};
